module.exports = __webpack_public_path__ + "img/enojado.fb0717a0.png";